import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CaFormFieldComponent, CaHint, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';

@Component({
	selector: 'app-datos-proyecto',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		CaFormFieldComponent,
		CaLabel,
		CaInputDirective,
		CaHint,
		ReactiveFormsModule
	],
	templateUrl: './datos-proyecto.component.html',
	styleUrls: ['./datos-proyecto.component.scss']
})
export class DatosProyectoComponent {
	 @Input() form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.addFormControls();
  }

  private addFormControls(): void {
    this.form.addControl('nombre-proy', this.fb.control('', [Validators.required]));
  }
}
